import { create } from 'zustand';

export type UnitSystem = 'cm' | 'inch';

interface UIState {
  hactEnabled: boolean;
  toggleHact: (value?: boolean) => void;
  hidePrices: boolean;
  toggleHidePrices: () => void;
  setHidePrices: (value: boolean) => void;
  isSidebarOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
  unitSystem: UnitSystem;
  toggleUnitSystem: () => void;
  setUnitSystem: (value: UnitSystem) => void;
}

const getInitialHidePrices = (): boolean => {
  try {
    const v = localStorage.getItem('hidePrices');
    return v ? JSON.parse(v) : false;
  } catch {
    return false;
  }
};

const getInitialUnitSystem = (): UnitSystem => {
  try {
    const v = localStorage.getItem('unitSystem');
    return v === 'inch' ? 'inch' : 'cm';
  } catch {
    return 'cm';
  }
};

const getInitialHact = (): boolean => {
  try {
    const v = localStorage.getItem('hactEnabled');
    return v ? JSON.parse(v) : false;
  } catch {
    return false;
  }
};

export const useUIStore = create<UIState>((set) => ({
  hactEnabled: getInitialHact(),
  toggleHact: (value?: boolean) => set((state) => {
    const next = value ?? !state.hactEnabled;
    try { localStorage.setItem('hactEnabled', JSON.stringify(next)); } catch {}
    return { hactEnabled: next };
  }),
  hidePrices: getInitialHidePrices(),
  toggleHidePrices: () => set((state) => {
    const next = !state.hidePrices;
    try { localStorage.setItem('hidePrices', JSON.stringify(next)); } catch {}
    return { hidePrices: next };
  }),
  setHidePrices: (value: boolean) => set(() => {
    try { localStorage.setItem('hidePrices', JSON.stringify(value)); } catch {}
    return { hidePrices: value };
  }),
  isSidebarOpen: false,
  openSidebar: () => set(() => ({ isSidebarOpen: true })),
  closeSidebar: () => set(() => ({ isSidebarOpen: false })),
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  unitSystem: getInitialUnitSystem(),
  toggleUnitSystem: () => set((state) => {
    const next: UnitSystem = state.unitSystem === 'cm' ? 'inch' : 'cm';
    try { localStorage.setItem('unitSystem', next); } catch {}
    return { unitSystem: next };
  }),
  setUnitSystem: (value: UnitSystem) => set(() => {
    try { localStorage.setItem('unitSystem', value); } catch {}
    return { unitSystem: value };
  }),
}));

export default useUIStore;


